export const PLACEHOLDER_CATEGORIES = [
  {
    label: 'Persönliche Daten',
    placeholders: ['ANREDE', 'VORNAME', 'NACHNAME', 'GEBURTSTAG', 'GESCHLECHT', 'STATUS'],
  },
  {
    label: 'Kontaktdaten',
    placeholders: ['TELEFON', 'MOBILTELEFON', 'FAX', 'GESCHAEFTSEMAIL', 'PRIVATEEMAIL'],
  },
  {
    label: 'Adressdaten',
    placeholders: ['STRASSE', 'PLZ', 'ORT', 'LAND'],
  },
  {
    label: 'Abweichende Rechnungsadresse',
    placeholders: ['RA_STRASSE', 'RA_PLZ', 'RA_ORT', 'RA_LAND'],
  },
  {
    label: 'Vertrag & Firma',
    placeholders: [
      'RANG',
      'LEVEL',
      'FIRMA',
      'VERTRAGSART',
      'BERATERNUMMER',
      'MYJACK_UNIT',
      'MYJACK_LOGIN',
      'MANDATSREFERENZ',
      'VERTRAGSINHABER',
    ],
  },
  {
    label: 'System & Buchhaltung',
    placeholders: ['KREDITORENNUMMER', 'STEUERNUMMER', 'USTID', 'IBAN', 'BANKNAME', 'BIC', 'STARTDATUM', 'TEAMLEITER'],
  },
] as const;

export type PlaceholderKey = (typeof PLACEHOLDER_CATEGORIES)[number]['placeholders'][number];

/** Shared inventory for every editor and generation path that supports PRM template placeholders. */
export const KNOWN_PLACEHOLDER_KEYS: readonly PlaceholderKey[] = PLACEHOLDER_CATEGORIES.flatMap((category) => [
  ...category.placeholders,
]) as PlaceholderKey[];

export const PLACEHOLDER_EXAMPLE_VALUES: Readonly<Record<PlaceholderKey, string>> = {
  ANREDE: 'Herr',
  VORNAME: 'Max',
  NACHNAME: 'Mustermann',
  GEBURTSTAG: '15.03.1985',
  // RITA-1597: geschrieben wie im echten Vertrag (renderAdvisorTemplate: „Männlich“/„Weiblich“).
  GESCHLECHT: 'Männlich',
  STATUS: 'Aktiv',
  TELEFON: '+49 30 123456',
  MOBILTELEFON: '+49 170 1234567',
  FAX: '+49 30 123457',
  GESCHAEFTSEMAIL: 'max.mustermann@example.de',
  PRIVATEEMAIL: 'max.privat@example.de',
  STRASSE: 'Musterstraße 42',
  PLZ: '10115',
  ORT: 'Berlin',
  LAND: 'Deutschland',
  RA_STRASSE: 'Rechnungsweg 7',
  RA_PLZ: '10117',
  RA_ORT: 'Berlin',
  RA_LAND: 'Deutschland',
  RANG: 'Gold',
  LEVEL: 'Senior',
  // RITA-1597: FIRMA ist die eigene Marke (Beispiel: die erste Marke), VERTRAGSINHABER der abweichende
  // Vertragsinhaber des Beraters – in der Briefvorlagen-Vorschau als Firma, damit der Unterschied sichtbar ist.
  FIRMA: 'Mein Urlaubsglück GmbH',
  VERTRAGSART: 'Standard',
  BERATERNUMMER: 'B-2026-0042',
  MYJACK_UNIT: 'Unit-Berlin',
  MYJACK_LOGIN: 'mmustermann',
  MANDATSREFERENZ: 'MR-2026-0042',
  VERTRAGSINHABER: 'Firma Muster Reisen GmbH',
  KREDITORENNUMMER: 'K-100042',
  STEUERNUMMER: '27/123/45678',
  USTID: 'DE123456789',
  IBAN: 'DE89 3704 0044 0532 0130 00',
  BANKNAME: 'Commerzbank',
  BIC: 'COBADEFFXXX',
  STARTDATUM: '01.01.2026',
  TEAMLEITER: 'Anna Schmidt',
};
